import React, { useState, useEffect } from "react";

import ProgramManagerHeader from "./Header.jsx";
import ProgramManagerTable from "./Table.jsx";

import { getProgramManagers, getContractHoldersGroups } from "../../../api/contractHolders.js";
import { removedBannedChs } from "../../../util/bannedChs.js";

import { SEARCH_TYPE_NAME } from "../../../constants.js";

/**
 * @typedef {import("../../../jsdoc/ProgramManager.js").ProgramManager} ProgramManager
 * @typedef {import("../../../jsdoc/ContractHolderGroup.js").ContractHolderGroup} ContractHolderGroup
 */

export default function ProgramManagers({ setFetchError }) {
  /** @type {[ProgramManager[], React.Dispatch<React.SetActionState<ProgramManager[]>>]} */
  const [programManagers, setProgramManagers] = useState([]);
  /** @type {[ContractHolderGroup[], React.Dispatch<React.SetActionState<ContractHolderGroup[]>>]} */
  const [contractHoldersGroups, setContractHoldersGroups] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState(SEARCH_TYPE_NAME);
  const [options, setOptions] = useState({
    groupOptions: {},
    otherOptions: [],
  });

  useEffect(() => {
    getProgramManagers()
      .then((programManagersData) => {
        setProgramManagers(removedBannedChs(programManagersData));
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  useEffect(() => {
    getContractHoldersGroups()
      .then((contractHoldersGroups) => {
        setContractHoldersGroups(contractHoldersGroups);
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  let content;

  if (!programManagers.length) {
    content = <div>Loading Program Managers Data...</div>;
  } else {
    content = (
      <ProgramManagerTable
        programManagers={programManagers}
        searchValue={searchValue}
        searchType={searchType}
        options={options}
      />
    );
  }

  return (
    <div className="container-fluid" id="inner">
      <ProgramManagerHeader
        contractHoldersGroups={contractHoldersGroups}
        options={options}
        setOptions={setOptions}
        searchType={searchType}
        setSearchType={setSearchType}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      {content}
    </div>
  );
}
